import React, {useContext, createContext, useState, Fragment} from 'react';
import API from "../Network/API";
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';

toast.configure();

export default function LoginVerify() {
    const [email, setEmail] = useState('');
    const [isLoading, setLoading] = useState('');
    const [password, setPassword] = useState('');
    const handleSubmit = event => {
        event.preventDefault();
        if (typeof email == "") {
            toast.error('Email is not correct!');
            return false;
        }
        setLoading(true);
        var data = {
            'email': localStorage.getItem('requestEmail'),
            'code': password
        }
        API.post('loginVerify', data, {
            onUploadProgress: progressEvent => {
                // console.log("Progress: " + progressEvent.loaded / progressEvent.total);
            }
        }).then(response => {
            setLoading(false);
            toast.success('Login success');
            if (response.data.success === true) {
                localStorage.setItem("connect_token", response.data.data.token);
                localStorage.setItem("profile_img", response.data.data.avatar);
                localStorage.setItem("profile_name", response.data.data.name);
                localStorage.setItem("user_data", JSON.stringify(response.data.data.userData));
                if (response.data.data.name == null || response.data.data.name =='') {
                    window.location = "/name-verify";
                }else if(localStorage.getItem("set_meeting_url")!=null){
                    window.location.href=localStorage.getItem("set_meeting_url");
                }else if(localStorage.getItem("url")!=null){
                    window.location.href=localStorage.getItem("url");
                } else {
                    window.location.href = "/";
                }
            }
        }).catch((error) => {
            setLoading(false);
            toast.error('Login Failed.Please try again.');
        });
    }
    return (
        <Fragment>
            <header className="header-area shadow-sm">
                <nav className="navbar navbar-expand-lg navbar-light">
                    <div className="container">
                    <div className="logo">
                        <img src="assets/img/logo.png" alt="ConnectsApp" style={{'maxWidth':'200px'}} />
                    </div>
                    </div>
                </nav>
            </header>

            <div className="login-wrap pt-md-80 pt-2 mb-80">
                <div className="container">
                    <div className="row login-row">
                        <div className="col-xl-6 order-xl-1 order-1 d-flex align-items-center justify-content-center py-2 py-xl-0">
                            <img className="img-fluid d-block d-xl-none" style={{'width': '70%', 'maxWidth': '400px'}} src="assets/img/app-hero.webp" alt="" />
                            <img className="img-fluid d-none d-xl-block" src="assets/img/app-hero.webp" alt="" />
                        </div>
                        <div className="col-xl-6 bg-white order-xl-2 order-2">
                            <div className="row login-columns align-items-center justify-content-center min-vh-xl-100">
                                <div className="col-10 col-md-8 col-lg-6 col-xl-6">
                                    <div className="align-items-center justify-content-center text-center py-3 py-xl-4">
                                        <h5 className="text-black pb-1 pb-xl-3 mb-2 mb-xl-0">
                                            Enter Verification Code
                                        </h5>
                                        <p className="text-black-50 mb-3 mb-xl-4">
                                            Please check your inbox for verification code sent to <br/>
                                            <b className="text-black">{localStorage.getItem('requestEmail')}</b>
                                        </p>
                                        <form onSubmit={handleSubmit}>
                                            <div className="form-group icon-input mb-2 mb-xl-3">
                                                <input
                                                    onChange={(e) => setPassword(e.target.value)} 
                                                    type="text"
                                                    className="form-control form-control login-w-button login-w-input"
                                                    aria-describedby="codeHelp"
                                                    placeholder="Enter verification code"
                                                />
                                            </div>
                                            <span style={{ color: "red" }} />
                                            <div className="form-group mb-1">
                                                <button type={'submit'} className="login-w-button btn btn-dark w-100 mb-2 mb-xl-3 gap-1" role="button">
                                                    <i className="fa-solid fa-shield-check mx-2" />
                                                    Verify Code
                                                    {isLoading ? (
                                                        <span
                                                            className="spinner-border spinner-border-sm ml-3"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                    ) : (
                                                        <span></span>
                                                    )}
                                                </button>
                                                <p className="text-black-50 mt-0 mb-2 mb-xl-3 small">
                                                    Didn't receive the code? <Link className="text-primary" to={'/login'}>Resend</Link>
                                                </p>
                                                <p className="text-black-50 mt-0 mb-2 mb-xl-0 small">
                                                    By continuing you agree to our <Link className="text-primary" to={'/page/terms'} target='_blank'>terms
                                                    & conditions</Link> 
                                                    {" "}and{" "} 
                                                    <Link to={'/page/policy'} target='_blank' className="text-primary">privacy policy</Link>
                                                </p>
                                            </div>
                                        </form>
                                        <div className="col-sm-12 pt-3 pt-xl-5">
                                            <div className="mobile-space-between">
                                                <a target="_blank" href="https://play.google.com/store/apps/details?id=com.tryonex.connects" className="android">
                                                    <img src="assets/img/playstore.svg" />
                                                </a>
                                                <a target="_blank" href="https://apps.apple.com/gb/app/connects-social-and-meeting/id1567949697" className="android">
                                                    <img src="assets/img/appstore.svg" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}